import { render, staticRenderFns } from "./BuyTokensDialogue.vue?vue&type=template&id=4307678d&"
import script from "./BuyTokensDialogue.vue?vue&type=script&lang=js&"
export * from "./BuyTokensDialogue.vue?vue&type=script&lang=js&"
import style0 from "./BuyTokensDialogue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports